import React, { useEffect, useState } from "react";
import Bannerheader from "../Bannerheader"; // Add this import
import "./Myorders.css";

function Myorders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      setLoading(true);
      // Get user ID from localStorage (assuming it's stored during login)
      const userId = localStorage.getItem("userId"); // or "user_id" or "id"
      
      if (!userId) {
        console.log("No user ID found");
        setOrders([]);
        return;
      }

      const response = await fetch(
        `https://vogelkoparchitects.com/api/ecom/orders-by-user/${userId}/`
      );

      if (!response.ok) {
        throw new Error("Failed to fetch orders");
      }

      const data = await response.json();
      setOrders(data);
    } catch (error) {
      console.log("Error fetching orders:", error);
    } finally {
      setLoading(false);
    }
  };



  // Show loading state
  if (loading) {
    return (
      <div>
        <Bannerheader /> {/* Changed from Header to Bannerheader */}
        <div className="orders-container">
          <h2 className="orders-title">My Orders</h2>
          <div className="loading">Loading orders...</div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Bannerheader /> {/* Changed from Header to Bannerheader */}
      <div className="orders-container">
        <h2 className="orders-title">My Orders</h2>
        
        {orders.length === 0 ? (
          <div className="no-orders">No orders found</div>
        ) : (
          orders.map((order) => (
            <div className="order-card" key={order.id}>
              <div className="order-top">
                <div>
                  <h3>Order #{order.order_no}</h3>
                  <p className="order-date">
                    Order Date : {new Date(order.created_at).toLocaleDateString()}
                  </p>
                </div>
                <span className={`order-status ${order.status}`}>
                  {order.status}
                </span>
              </div>

              {order.items.map((item) => (
                <div className="product-row" key={item.id}>
                  <img
                    src={item.product_image}
                    alt={item.product_name}
                    className="product-image"
                  />
                  <div className="product-details">
                    <h4>{item.product_name}</h4>
                    <p>Qty : {item.quantity}</p>
                    <p>Price : ₹{item.price_per_unit}</p>
                  </div>
                  <div className="product-total">
                    ₹{item.total_price}
                  </div>
                </div>
              ))}

              
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default Myorders;